module.exports = __webpack_public_path__ + "img/end-arrow.bdcec1d9.png";